import React from 'react';
export function PrivacyPolicy() {
  return <div className="prose prose-sm max-w-none" data-id="element-296">
      <p className="text-gray-600 mb-4" data-id="element-297">
        <strong data-id="element-298">Última actualización:</strong> Enero 2025
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-299">
        1. Información que Recopilamos
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-300">
        Recopilamos información que nos proporcionas directamente cuando:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-301">
        <li data-id="element-302">Compras nuestro sistema de recetas</li>
        <li data-id="element-303">Te suscribes a nuestro newsletter</li>
        <li data-id="element-304">Nos contactas para soporte</li>
        <li data-id="element-305">Participas en nuestra comunidad</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-306">2. Uso de la Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-307">Utilizamos tu información para:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-308">
        <li data-id="element-309">Procesar tus compras y enviarte el contenido digital</li>
        <li data-id="element-310">Enviarte actualizaciones del producto y recetas nuevas</li>
        <li data-id="element-311">Responder a tus consultas y brindarte soporte</li>
        <li data-id="element-312">Mejorar nuestros productos y servicios</li>
        <li data-id="element-313">Cumplir con obligaciones legales</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-314">3. Protección de Datos</h3>
      <p className="text-gray-700 mb-4" data-id="element-315">
        Implementamos medidas de seguridad para proteger tu información
        personal:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-316">
        <li data-id="element-317">Encriptación SSL en todas las transacciones</li>
        <li data-id="element-318">Servidores seguros y protegidos</li>
        <li data-id="element-319">Acceso limitado a información personal</li>
        <li data-id="element-320">Cumplimiento con GDPR y regulaciones internacionales</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-321">4. Cookies</h3>
      <p className="text-gray-700 mb-4" data-id="element-322">
        Utilizamos cookies para mejorar tu experiencia en nuestro sitio. Puedes
        configurar tu navegador para rechazar cookies, aunque esto puede afectar
        algunas funcionalidades del sitio.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-323">5. Compartir Información</h3>
      <p className="text-gray-700 mb-4" data-id="element-324">
        No vendemos ni compartimos tu información personal con terceros,
        excepto:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-325">
        <li data-id="element-326">Procesadores de pago necesarios para completar transacciones</li>
        <li data-id="element-327">
          Proveedores de servicios que nos ayudan a operar nuestro negocio
        </li>
        <li data-id="element-328">Cuando sea requerido por ley</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-329">6. Tus Derechos</h3>
      <p className="text-gray-700 mb-4" data-id="element-330">Tienes derecho a:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-331">
        <li data-id="element-332">Acceder a tu información personal</li>
        <li data-id="element-333">Corregir información incorrecta</li>
        <li data-id="element-334">Solicitar la eliminación de tus datos</li>
        <li data-id="element-335">Cancelar suscripciones en cualquier momento</li>
        <li data-id="element-336">Presentar una queja ante autoridades de protección de datos</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-337">7. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-338">
        Para cualquier consulta sobre esta política de privacidad, contáctanos
        a:
        <br data-id="element-339" />
        <strong data-id="element-340">Email:</strong> privacidad@50recetasexpress.com
      </p>
    </div>;
}